<mat-form-field appearance="standard" *ngIf="countries">
  <mat-select type="country" placeholder="{{'country'| preventHardcoding}}" [(ngModel)]="selectedCountry">
    <mat-option *ngFor="let country of countries; trackBy: trackByFn" (click)="onCountrySelected(country)" (onSelectionChange)="onCountrySelectionChanged($event, country)" [value]="country">{{ country.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
